import { ReactNode } from 'react';

import { FormGrid } from './formGrid/FormGrid';
import { ControlledSelect } from './controlledSelect/ControlledSelect';

export const Form = ({ children }: { children?: ReactNode }) => <form>{children}</form>;

Form.Grid = FormGrid;
Form.ControlledSelect = ControlledSelect;
